module.exports = __webpack_public_path__ + "img/mh.cf0286fc.svg";